import React from 'react';
import { Row } from 'reactstrap';
const Skeleton = () => {
  const counter = [1, 2, 3];
  return <div className={'skeleton-section'} data-sentry-component="Skeleton" data-sentry-source-file="Skeleton.tsx">
   <div className={'skeleton-grid'}>
    <Row className={'g-3 mt-0'} data-sentry-element="Row" data-sentry-source-file="Skeleton.tsx">
     {counter.map((item, index) => <div className={'col-sm-12 col-md-6 col-lg-4'} key={index}>
       <div className={'skeleton-loading'}>
        <div className={'skeleton-thumb'}></div>
        <div className={'skeleton-bottom-section'}>
         <div className={'skeleton-title'} />
         <p className={'skeleton-description'} />
         <div className={'skeleton-link'} />
        </div>
       </div>
      </div>)}
    </Row>
   </div>
  </div>;
};
export default Skeleton;